import {SET_MY_ACCOUNT_POPUP_STATUS, SET_POPUP_NAVIGATION_STATUS, UPDATE_IS_MOBILE} from './types';

export const setMyAccountPopupState = (state) => async (dispatch) => {
    dispatch({
        type: SET_MY_ACCOUNT_POPUP_STATUS,
        payload: state
    });
};

export const setPopupNavigationStatus = (state) => async (dispatch) => {
    dispatch({
        type: SET_POPUP_NAVIGATION_STATUS,
        payload: state
    });
};

export const updateIsMobile = () => {
    return {
        type: UPDATE_IS_MOBILE
    }
}